import sector63 from "../../../../public/projects/sobha/images/sector63.webp";
import logo from "../../../../public/projects/sobha/logo/logo.png";
//Altus
import overviewImage_altus from "../../../../public/projects/sobha/images/altus/Overview/1.webp";
import bannerDesktopImage_altus from "../../../../public/projects/sobha/images/altus/Banner/1.webp";
import bannerMobileImage_altus from "../../../../public/projects/sobha/images/altus/Banner/2.webp";
import siteVisitBannerImage_altus from "../../../../public/projects/sobha/images/altus/SiteVisitBanner/1.webp";
import Location_altus from "../../../../public/projects/sobha/images/altus/Location/L1.webp";
import Hightlights_altus from "../../../../public/projects/sobha/images/altus/Highlights/1.webp";
import image1BHK_altus from "../../../../public/projects/sobha/images/altus/floorplan/1.webp";
import image2BHK_altus from "../../../../public/projects/sobha/images/altus/floorplan/2.webp";
import location_altus from "../../../../public/projects/sobha/images/altus/Overview/l.png";
import cal_altus from "../../../../public/projects/sobha/images/altus/Overview/c.png";
import newlaunch_altus from "../../../../public/projects/sobha/images/altus/Overview/n.png";
import g1_altus from "../../../../public/projects/sobha/images/altus/Gallery/1.webp";
import g2_altus from "../../../../public/projects/sobha/images/altus/Gallery/2.webp";
import g3_altus from "../../../../public/projects/sobha/images/altus/Gallery/3.webp";
import g4_altus from "../../../../public/projects/sobha/images/altus/Gallery/4.webp";
import g5_altus from "../../../../public/projects/sobha/images/altus/Gallery/5.webp";

//Sobha City
import overviewImage_sobhacity from "../../../../public/projects/sobha/images/sobhacity/Overview/1.webp";
import bannerDesktopImage_sobhacity from "../../../../public/projects/sobha/images/sobhacity/Banner/1.webp";
import bannerMobileImage_sobhacity from "../../../../public/projects/sobha/images/sobhacity/Banner/2.webp";
import siteVisitBannerImage_sobhacity from "../../../../public/projects/sobha/images/sobhacity/SiteVisitBanner/1.webp";
import Location_sobhacity from "../../../../public/projects/sobha/images/sobhacity/Location/L1.webp";
import Hightlights_sobhacity from "../../../../public/projects/sobha/images/sobhacity/Highlights/1.webp";
import image1BHK_sobhacity from "../../../../public/projects/sobha/images/sobhacity/floorplan/1.webp";

import image3BHK_sobhacity from "../../../../public/projects/sobha/images/sobhacity/floorplan/3.webp";
import image2BHK_sobhacity from "../../../../public/projects/sobha/images/sobhacity/floorplan/2.webp";
import location_sobhacity from "../../../../public/projects/sobha/images/sobhacity/Overview/l.png";
import cal_sobhacity from "../../../../public/projects/sobha/images/sobhacity/Overview/c.png";
import newlaunch_sobhacity from "../../../../public/projects/sobha/images/sobhacity/Overview/n.png";
import g1_sobhacity from "../../../../public/projects/sobha/images/sobhacity/Gallery/1.webp";
import g2_sobhacity from "../../../../public/projects/sobha/images/sobhacity/Gallery/2.webp";
import g3_sobhacity from "../../../../public/projects/sobha/images/sobhacity/Gallery/3.webp";
import g4_sobhacity from "../../../../public/projects/sobha/images/sobhacity/Gallery/4.webp";
import g5_sobhacity from "../../../../public/projects/sobha/images/sobhacity/Gallery/5.webp";

export const developersSobha = {
  name: `Sobha Properties in Gurugram`,
  properties: [
    {
      name: "International City",
      image: sector63,
      price: "On Request",
      location: "Sector 109",
      state: "Gurugram",
      projectlocation: "Dwarka Expressway",
      developer: "Sobha",
      bed: " 5 BHK",
      size: "....",
      url: ``,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "Sobha - City",
      image: sector63,
      price: "On Request",
      location: "Sector 108",
      state: "Gurugram",
      projectlocation: "Dwarka Expressway",
      developer: "Sobha",
      bed: "4 BHK",
      size: "....",
      url: `/sobha-city-sector-108-gurgaon`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "Sobha - Altus",
      image: sector63,
      price: "On Request",
      state: "Gurugram",
      location: "Sector 106",
      projectlocation: "Dwarka Expressway",
      projectlocation: "Golf Course Extention Road",
      bed: "4 - 5 BHK",
      size: "....",
      url: `/sobha-altus-sector-106-gurgaon`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
  ],
};

export const Headers = {
  logo: logo,
  data: {
    experience: `1995`,
    projects: `118`,
    ongoingprojects: `5`,
  },
  about: `Sobha Realty an international luxury real estate developer committed to redefining the art of living 
  by building sustainable communities. Established in 1976 as an interior decoration firm in Oman by the iconic 
  PNC Menon a visionary leader in the space, we have grown our presence world-over with developments and investments 
  in the UAE, Oman, Bahrain, Brunei, and India.`,
};
export const projectsSobha = {
  sobhacity: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_sobhacity,
      bannerMobileImage: bannerMobileImage_sobhacity,
      textOverlay: "",
      data: {
        title: "Sobha City Sector 108",
        subtitle: "Gurgaon",
        starting_price: "On Request",
        rerano: "GGM/340/72/2019/34",
        payment_plan: "....",
        status: "Ready To Move",
      },
    },
    overview: {
      heading: "Sobha City 108",
      description: [
        `Sobha City, located in Sector 108, Gurgaon, is a housing society that is ready for occupancy. It features apartments across a range of budgets. These units perfectly blend comfort and style, tailored to meet your needs and preferences. This project offers 2BHK, 3BHK, and 4BHK apartments. As families have begun to move in, this housing society is now truly ready to be called home. Here are some key characteristics of the Sobha City housing society:

Sobha City in Sector 108 comprises 22 towers, each with 24 floors, providing a total of 1,728 available units.

Occupying a vast area of 39 acres, Sobha City Sector 108, Gurgaon stands out as one of the more spacious housing societies in the Gurgaon locale. With all essential amenities in place, Sobha City is in alignment with both your budget and lifestyle.
`,
      ],
      image: overviewImage_sobhacity,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass:"",
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass:"",
          title: "....",
          subtitle: "Payment Plan",
        },
        {
          iconClass: "",
          title: "Ongoing",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_sobhacity,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK",
          area: "1381 - 1692 sq. ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK",
          area: "1711 - 2343 sq.ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "2423 - 2963 sq.ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "2 BHK",
        area: "1381 - 1692 sq. ft.",
        price: "On Request",
        image: image1BHK_sobhacity,
      },
      {
        type: "3 BHK",
        area: "1711 - 2343 sq.ft.",
        price: "On Request",
        image: image2BHK_sobhacity,
      },
      {
        type: "4 BHK",
        area: "2423 - 2963 sq.ft.",
        price: "On Request",
        image: image3BHK_sobhacity,
      },
    ],

    highlights: {
      images: Hightlights_sobhacity,
      tagline: "Highlights",
      features: [
        "Twin clubhouse in 40,000+ sq. ft. area.",
        "Apartments ranging from 2 BHK to 4 BHK.",
        "Price starts from only 2.75 Cr Onwards.",
        "8+ acre area for landscape garden.",
        "Extra wide resort type lakelet .",
      ],
    },

    location: {
      image: Location_sobhacity,
      places: [
        { place: "Hamoni Golf Camp, 9.1 KM" },
        { place: "Dwarka Expressway, 7.4 Km" },
        { place: "Rions Hospital, 3.8 Km" },
        { place: "Gurgaon Railway Station, 4 KM" },
      ],
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_sobhacity },
        { image: g2_sobhacity },
        { image: g3_sobhacity },
        { image: g4_sobhacity },
        { image: g5_sobhacity },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy lsto Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Sobah City 108, kindly share more details.",
    },

    faq: [
      
      {
        question: "Where is SOBHA City located?",
        answer: `SOBHA City is strategically located in Sector 108, Gurgaon, near Dwarka Expressway, providing excellent connectivity to Delhi, IGI Airport, and major commercial hubs.`,
      },
      {
        question: "What types of apartments are available at SOBHA City?",
        answer: `The project offers spacious 2 and 3 BHK apartments with modern layouts, premium fittings, and large balconies to enhance the living experience.`,
      },
      {
        question: "What are the key amenities at SOBHA City?",
        answer: `The project includes a clubhouse, Olympic-sized swimming pool, cricket ground, multiple sports courts, jogging tracks, a gym, and landscaped gardens.`,
      },
      {
        question: "How well is SOBHA City connected to major locations?",
        answer: `It is well-connected via Dwarka Expressway, NH-8, and upcoming metro stations, offering seamless travel to Delhi, Gurgaon, and IGI Airport.`,
      },
      {
        question: "What makes SOBHA City, Sector 108, Gurgaon a standout choice for homebuyers?",
        answer: `SOBHA City in Sector 108, Gurgaon, is a standout choice for homebuyers seeking a luxurious and well-connected lifestyle.`,
      },
      {
        question: "What is the total area of SOBHA City?",
        answer: `The project is spread over approximately 39 acres, featuring vast open spaces, lush greenery, and thoughtfully designed infrastructure.`,
      },
      {
        question: "Who is the developer of SOBHA City?",
        answer: `SOBHA Limited, a renowned real estate developer known for its high-quality construction and premium residential projects, is behind SOBHA City. `,
      },
      {
        question: "Is SOBHA City RERA-approved?",
        answer: `Yes, SOBHA City is RERA-approved, ensuring transparency and security for homebuyers.`,
      },
      {
        question: "What is the price range of apartments in SOBHA City?",
        answer: `The price of apartments varies based on size and configuration.`,
      },
      {
        question: "Are there any commercial spaces within the project?",
        answer: `No, SOBHA City is purely a residential project designed to provide a peaceful and luxurious living environment.`,
      },
    ],
    similar: {
      properties: [
        {
          name: "International City",
          image: sector63,
          price: "On Request",
          location: "Sector 109",
          state: "Gurugram",
          projectlocation: "Dwarka Expressway",
          developer: "Sobha",
          bed: " 5 BHK",
          size: "....",
          url: ``,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },

        {
          name: "Sobha - Altus",
          image: sector63,
          price: "On Request",
          state: "Gurugram",
          location: "Sector 106",
          projectlocation: "Dwarka Expressway",
          projectlocation: "Golf Course Extention Road",
          bed: "4 - 5 BHK",
          size: "....",
          url: `/sobha-altus-sector-106-gurgaon`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
  altus: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_altus,
      bannerMobileImage: bannerMobileImage_altus,
      textOverlay: "",
      data: {
        title: "Sobha Altus",
        subtitle: "Sector 106, Gurgaon",
        starting_price: "On Request",
        rerano: "GGM/828/560/2024/55",
        payment_plan: "....",
        status: "New Launch",
      },
    },
    overview: {
      heading: "Sobha Altus",
      description: [
        `For those interested in purchasing a residential property, we present one of the finest options in Gurgaon, located at Sector 106. Introducing Sobha Altus, one of the latest residential addresses for homebuyers. Sobha Altus Sector 106, Gurgaon offers a selection of apartments and studio apartments for sale. This project is currently a new launch and is anticipated to be completed by December 2028, providing a variety of options across different budget ranges. 

Sobha Altus Gurgaon is a registered housing society under RERA, ensuring that all project information is accessible on the state RERA website for potential buyers and investors. The RERA registration number for this project is GGM/828/560/2024/55. 

Sobha is a well-known real estate brand within Gurgaon. The builder has successfully delivered 139 projects to date, with an additional 13 upcoming. Currently, there are 22 projects by this developer that are still under construction.`,
      ],
      image: overviewImage_altus,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_altus,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_altus,
          title: "....",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_altus,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_altus,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "4 BHK",
          area: "3045 - 3340 sq.ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },
        {
          type: "5 BHK",
          area: "3690 - 3853 sq.ft",
          price: "On Request",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "4 BHK",
        area: "3045 - 3340 sq.ft.",
        price: "On Request",
        image: image1BHK_altus,
      },
      {
        type: "5 BHK",
        area: "3690 - 3853 sq.ft",
        price: "On Request",
        image: image2BHK_altus,
      },
    ],

    highlights: {
      images: Hightlights_altus,
      tagline: "Highlights",
      features: [
        "Residential development spread over 5.51 acres ",
        "A total of 293 residential units",
        "Featuring a combination of retail space, swimming pool, and upscale urban residences ",
        "Special inclusion of a multifunctional room and a private terrace",
        "Three towers set apart to ensure privacy, natural light, and scenic views",
      ],
    },

    location: {
      image: Location_altus,
      places: [
        { place: "Red Roses Public School - 2.3 km" },
        { place: "Euro International School - 0.75 km" },
        { place: "Mothers Care Public School - 0.7 km" },
        { place: "Dwarka Sector 21 Metro Station - 7 km" },
      ],
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_altus },
        { image: g2_altus },
        { image: g3_altus },
        { image: g4_altus },
        { image: g5_altus },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy lsto Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Mantri Energia, kindly share more details.",
    },

    faq: [
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
    ],
    similar: {
      properties: [
        {
          name: "International City",
          image: sector63,
          price: "On Request",
          location: "Sector 109",
          state: "Gurugram",
          projectlocation: "Dwarka Expressway",
          developer: "Sobha",
          bed: " 5 BHK",
          size: "....",
          url: ``,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "Sobha - City",
          image: sector63,
          price: "On Request",
          location: "Sector 108",
          state: "Gurugram",
          projectlocation: "Dwarka Expressway",
          developer: "Sobha",
          bed: "4 BHK",
          size: "....",
          url: `/sobha-city-sector-108-gurgaon`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
};
